import { render, staticRenderFns } from "./ChangeUserImgPage.vue?vue&type=template&id=5d15c727"
import script from "./ChangeUserImgPage.vue?vue&type=script&lang=js"
export * from "./ChangeUserImgPage.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserImgPage.vue?vue&type=style&index=0&id=5d15c727&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports